(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GW-ingredients-swap"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SECTION_SELECTOR = '[data-gw-ia]';
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

    function init(root) {
      if (!root) return;

      const items  = Array.from(root.querySelectorAll('[data-gw-ia-item]'));
      const images = Array.from(root.querySelectorAll('[data-gw-ia-image]'));

      if (!items.length) return;

      const setActiveImage = (imageId) => {
        if (!images.length) return;
        images.forEach((img) => {
          const active = img.id === imageId;
          img.classList.toggle('is-active', active);
          img.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const closeOthers = (current) => {
        if (root.getAttribute('data-gw-single-open') !== 'true') return;
        items.forEach((d) => { if (d !== current) d.open = false; });
      };

      // ✅ MOBILE: force everything open + disable closing
      if (isMobile()) {
        items.forEach((details) => { details.open = true; });

        // default active image = first
        if (items[0]) setActiveImage(items[0].dataset.imageId);

        // lock summaries so they can't toggle; still swap images
        items.forEach((details) => {
          const summary = details.querySelector('summary');
          if (!summary || summary.dataset.gwLocked === '1') return;

          summary.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            details.open = true; // re-force open
            setActiveImage(details.dataset.imageId);
          }, true);

          details.addEventListener('toggle', () => {
            if (!details.open) details.open = true;
          });

          summary.setAttribute('aria-disabled', 'true');
          summary.dataset.gwLocked = '1';
        });

        return; // important: skip desktop accordion logic
      }

      // DESKTOP / NON-MOBILE: normal behaviour
      if (root.getAttribute('data-gw-start-collapsed') === 'true') {
        items.forEach(d => d.open = false);
        if (items[0]) setActiveImage(items[0].dataset.imageId);
      } else {
        const initiallyOpen = items.find(d => d.open) || items[0];
        if (initiallyOpen) {
          initiallyOpen.open = true;
          setActiveImage(initiallyOpen.dataset.imageId);
        }
      }

      items.forEach((details) => {
        const summary = details.querySelector('summary');
        if (summary && !summary.dataset.gwBound) {
          summary.addEventListener('click', () => {
            requestAnimationFrame(() => {
              if (details.open) {
                closeOthers(details);
                setActiveImage(details.dataset.imageId);
              }
            });
          });
          summary.dataset.gwBound = '1';
        }

        if (!details.dataset.gwBound) {
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            closeOthers(details);
            setActiveImage(details.dataset.imageId);
          });
          details.dataset.gwBound = '1';
        }
      });
    }

    document.querySelectorAll(SECTION_SELECTOR).forEach(init);

    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target?.querySelector(SECTION_SELECTOR) || e.target?.closest(SECTION_SELECTOR);
      if (root) init(root);
    });

let wasMobile = isMobile();

window.addEventListener('resize', () => {
  const nowMobile = isMobile();

  if (nowMobile === wasMobile) return;

  wasMobile = nowMobile;
  document.querySelectorAll(SECTION_SELECTOR).forEach(init);
}, { passive: true });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
